import React from 'react';
import { useTranslation } from 'react-i18next'; // For language handling
import { Link } from 'react-router-dom'; // Import Link from react-router-dom

import landIcon from '../assets/icons/land.svg';
import buildingIcon from '../assets/icons/building.svg';
import landParcelsIcon from '../assets/icons/land2.svg';
import utilitiesIcon from '../assets/icons/utilities.svg';

function Geodesy() {
  const { t } = useTranslation(); // Hook for translation

  return (
    <div >
    {/* Hero Section */}
    <div className="hero-banner">
      <div className="hero-content" >
        <h3 style={{ color: 'black' }}>{t('geodesy_def_title')} </h3>
        <p style={{ textAlign: 'justify' }}>{t('geodesy_def')}</p>
        <br />
        <h3 style={{ color: 'black' }}>{t('ngi_def_title')} </h3>
        <p style={{ textAlign: 'justify' }}>{t('ngi_def')}</p>
      </div>
    </div>
    

    {/* Content Section */}
    <section class="our-industry">
      <div class="industry-grid" style={{margin: "6%"}}>
      <div class="industry-item">
          <Link className="nav-link" to="/Geodesy/Sansrs">
      
          <img src={landIcon} alt="KSA CORS" />
          <p>{t('sansrs_title')} </p></Link>
        </div>
        <div class="industry-item">
        <Link className="nav-link" to="/Geodesy/KSACors">
        <img src={landParcelsIcon} alt="KSA CORS" />
          <p >{t('ksa_cors_title')}</p></Link>
        </div>
        <div class="industry-item">
        <Link className="nav-link" to="/Geodesy/NGN">
        <img src={landIcon} alt="National Gravity Network" />
         <p >{t('ngn_title')}</p></Link>
        </div>
        <div class="industry-item">
        <Link className="nav-link" to="/Geodesy/NVN">
          <img src={buildingIcon} alt="National Vertical Network" />
          <p>{t('nvn_title')}</p></Link>
        </div>
        <div class="industry-item">
        <Link className="nav-link" to="/Geodesy/GeodeticTools">
          <img src={utilitiesIcon} alt="Geodetic Tools" />
          <p >{t('geodtool_title')}</p></Link>
        </div>
       {/* <div class="industry-item">
        <Link className="nav-link" to="/ComingSoon">
          <img src={landIcon} alt="FAQ" />
          <p>{t('faq_title')}</p></Link>
        </div> */}
        
      </div>
    </section>
    
  </div>
);
}

export default Geodesy;
